/** @file `accept` filters of the import file pickers (PSD files; PNG files). */

export const IMPORT_ACCEPT = { psd: '.psd,image/vnd.adobe.photoshop', png: '.png,image/png' } as const;
